import styled from '@emotion/styled/macro';
import TabListWrapper from 'components/utils/TabListWrapper';
import { Tabs, TabList, Tab, TabPanels, TabPanel } from '@chakra-ui/react';

const AutoformTabs = ({ variant, tables, renderTabPanel, onTabOpen }) => {
    return (
        <Tabs isLazy variant={variant} onChange={(index) => onTabOpen && onTabOpen(tables[index])}>
            <StyledTabList>
                <TabListWrapper>
                    {tables.map((table, index) => (
                        <StyledTab key={index}>{table.name}</StyledTab>
                    ))}
                </TabListWrapper>
            </StyledTabList>

            <TabPanels mt={4}>
                {tables.map((table, index) => (
                    <TabPanel key={index}>{renderTabPanel(table)}</TabPanel>
                ))}
            </TabPanels>
        </Tabs>
    );
};

// @todo duplicate styles in items
const StyledTabList = styled(TabList)`
    overflow-x: auto;
    overflow-y: hidden;
    padding: 5px;
    border-bottom: 1px solid var(--chakra-colors-gray-200);

    [aria-selected='true'] {
        border-bottom: 4px solid var(--chakra-colors-blue-400);
    }

    [role='tab']:not([aria-selected='true']):hover {
        color: var(--chakra-colors-blue-400);
    }
`;

const StyledTab = styled(Tab)`
    padding: 16px 0;
    margin-right: 24px;
    margin-bottom: 0;

    :focus {
        border-radius: var(--chakra-radii-base);
    }

    .tooltip_wrapper {
        transform: translate(-50%, -110%) !important;
    }
`;

export default AutoformTabs;
